import React from 'react'
import { pt } from 'common-data/proptypehelpers'
import { Col } from './Col'
import { FAIcon } from './FAIcon'
import { Button } from './Button'
import { FormBoxContext } from './FormBoxContext'
import _ from 'common-tools/LodashHelper'
import Skeleton from 'react-loading-skeleton'
import { log } from 'common-tools/index'
import clsx from 'clsx'

export const FieldLayoutSizes = {
  Full: { sm: 12, md: 12, lg: 12, xl: 12 },
  Half: { sm: 12, md: 6, lg: 6, xl: 6 },
  Third: { sm: 12, md: 4, lg: 4, xl: 4 },
  Quarter: { sm: 12, md: 3, lg: 3, xl: 3 },
  One: { sm: 12, md: 1, lg: 1, xl: 1 },
  Two: { sm: 12, md: 2, lg: 2, xl: 2 },
  Three: { sm: 12, md: 3, lg: 3, xl: 3 },
  Four: { sm: 12, md: 4, lg: 4, xl: 4 },
  Five: { sm: 12, md: 5, lg: 5, xl: 5 },
  Six: { sm: 12, md: 6, lg: 6, xl: 6 },
  Seven: { sm: 12, md: 7, lg: 7, xl: 7 },
  Eight: { sm: 12, md: 8, lg: 8, xl: 8 },
  Nine: { sm: 12, md: 9, lg: 9, xl: 9 },
  Ten: { sm: 12, md: 10, lg: 10, xl: 10 },
  Eleven: { sm: 12, md: 11, lg: 11, xl: 11 },
  Middle: { sm: { size: 12, offset: 0 }, md: { size: 10, offset: 2 }, lg: { size: 6, offset: 3 }, xl: { size: 4, offset: 4 } }
}

export class FieldLayoutBox extends React.Component {
  static contextType = FormBoxContext
  static propTypes = {
    WrappedCtrl: pt.shape({
      meta: pt.object,
      helpText: pt.string,
      label: pt.string,
      caption: pt.string,
      input: pt.shape({
        value: pt.any,
        onChange: pt.func,
        onBlur: pt.func,
        name: pt.string.isRequired,
        onFocus: pt.func
      })
    }),
    formGroupProps: pt.object,
    children: pt.func.isRequired,
    hide: pt.bool.isRequired,
    readonly: pt.bool,
    debugMode: pt.bool
  }

  static defaultProps = {
    hide: false,
    formGroupProps: null,
    debugMode: false
  }

  renderDebugInfo = (field, value) => {
    const { debugActionSetup } = this.context
    if (debugActionSetup) {
      return <React.Fragment>
        <span color='info'>{`Field: ${field}`} <FAIcon {...debugActionSetup.iconProps} onClick={_.isFunction(debugActionSetup) ? debugActionSetup.onClick.bind(this, { type: 'Field', data: field }) : undefined} /></span>
        <span color='info'>{`Value: ${value}`} <FAIcon {...debugActionSetup.iconProps} onClick={_.isFunction(debugActionSetup) ? debugActionSetup.onClick.bind(this, { type: 'Value', data: value }) : undefined} /></span>
      </React.Fragment>
    } else {
      return <React.Fragment>
        <span color='info'>{`Field: ${field}`}</span>
        <span color='info'>{`Value: ${value}`}</span>
      </React.Fragment>
    }
  }

  render () {
    const { meta, label, caption, layout, hide,
      input: { value, onChange, onBlur, name, onFocus },
      placeHolder, children,
      readonly: localReadOnly, 'data-tid': testId = '', debugMode: localDebugMode = false, isFieldSet = false } = this.props
    const { loading, readonly: contextReadOnly, sideEffects = {}, debugMode: contextDebugMode = false } = this.context

    const effects = _.get(sideEffects, name) || {}

    if (hide || effects.hide) {
      return null
    }

    let showError = false
    showError = meta.touched === true && meta.invalid === true
    let errorMessage = showError ? meta.error || '' : ''

    if (_.isArray(errorMessage) === true) {
      showError = false
      log.Error('Field Layout Array Error', { Errors: errorMessage })
    }

    let readonly = contextReadOnly === true

    if (localReadOnly === true) {
      readonly = true
    }

    if (effects.readOnly === true) {
      readonly = true
    }

    let debugMode = contextDebugMode === true

    if (localDebugMode === true) {
      debugMode = true
    }

    const ctrl = children({
      showError,
      value,
      onChange,
      onBlur,
      name,
      onFocus,
      placeHolder,
      loading,
      testId,
      readonly,
      caption,
      label,
      sideEffects: effects,
      isFieldSet
    })

    if (isFieldSet === true && !readonly) {
      var fieldLayout = (
      <>
        <fieldset className="small-12 cell">
          <legend>{label}</legend>
          {loading ? <Skeleton /> : ctrl}
        </fieldset>
        {showError
          ? <span className="form-error no-hide">{errorMessage}</span>
          : null
        }
        {caption
          ? <p className='help-text'>{caption}</p>
          : null
        }
        {debugMode
          ? <p className='debug-text'>{`Field: ${name}  -  Value: ${value}`}</p>
          : null
        }
      </>
      )
    } else {
      var fieldLayout = (
      <>
        <label className={clsx(showError && 'is-invalid-label')}>{label}
          {loading ? <Skeleton /> : ctrl}
        </label>
        {showError
          ? <span className="form-error no-hide">{errorMessage}</span>
          : null
        }
        {caption
          ? <p className='help-text'>{caption}</p>
          : null
        }
        {debugMode
          ? <p className='debug-text'>{`Field: ${name}  -  Value: ${value}`}</p>
          : null
        }
      </>

      )
    }

    if (layout) {
      return (<Col layout={layout} className={clsx(showError && 'pulse')}>
        {fieldLayout}
      </Col>)
    } else {
      return fieldLayout
    }
  }
}

export function FieldLayoutGroup (props) {
  const { groupClassName, groupLabelClassName, groupButtonClassName, groupButton, groupLabel, children } = props

  if (groupButton || groupLabel) {
    if (groupButton) {
      var { text: buttonText, ...buttonProps } = groupButton
    }

    return <div className={groupClassName || 'input-group'}>
      {groupLabel
        ? <span className={groupLabelClassName || 'input-group-label'}>{groupLabel}</span>
        : null
      }
      {children}
      {groupButton
        ? <div className={groupButtonClassName || 'input-group-button'}>
          <Button {...buttonProps}>{buttonText}</Button>
        </div>
        : null
      }
    </div>
  } else {
    return children
  }
}
